import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
} from "@progress/kendo-react-grid";
import "./tablestyles.scss";
import { Icon } from "@iconify/react";

const TimeSheetHistory = (props: any) => {

    const checkStatus = (status: string) => {
        switch (status) {
            case '':
                return {
                    value: 'Working',
                    class: ' '
                }
            case 'Working':
                return {
                    value: 'Working',
                    class: ' '
                }
            case 'Weekend':
                return {
                    value: 'Weekend',
                    class: 'statusText Yellow'
                }
            case 'Holiday':
                return {
                    value: 'Holiday',
                    class: 'statusText Red'
                }
            default:
                return {
                    value: status,
                    class: 'statusText Red'
                }
        }
    }

    const statusCell = (props: GridCellProps) => {
  
        return (
            <td>    
                <div className={checkStatus(props.dataItem.day_status).class}>
                    {checkStatus(props.dataItem.day_status).value}
                </div>
        </td>
        )
    }
    

  return (
    <div className="tableStyle no-min-height no-top-padd">
        <Grid
            data={props.data}           
        >
            <GridNoRecords>
                <div className="noData">
                  <Icon icon="mdi:smiley-neutral-outline" />
                  No data to display
                </div>
            </GridNoRecords>
            <Column field="day" title="Day" cell={dayCell} />
            <Column field="date" title="Date" cell={dateCell}  />
            <Column field="hours" title="No of Working Hours/H"   cell={hoursCell}/>
            <Column field="workDescription" title="Work Description"  cell={workDescriptionCell}/>
            <Column field="status" title="Status" cell={statusCell} />
        </Grid>  
    </div>
  )
}

export default TimeSheetHistory;

const dayCell = (props: GridCellProps) => {

    return (
        <td>
            {props.dataItem.entry_day}
        </td>
    )
}

const dateCell = (props: GridCellProps) => {
  
    let entry_date = new Date(parseInt(props.dataItem.entry_date)).toDateString();
    return (
        <td>
            {entry_date}
        </td>
    )
}

const hoursCell = (props: GridCellProps) => {

    return (
        <td>
            {props.dataItem.workhours_count}
        </td>
    )
}

const workDescriptionCell= (props: GridCellProps) => {
  
    return (
        <td>
            {props.dataItem.work_description}
        </td>
    )
}

